import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import Typography from '../../../../Typography';
import { TableNoDataImage } from './Image';
import { TableNoDataInnerWrapper, TableNoDataWrapper } from './styled';
export const TableNoData = memo(function TableNoData({ className, message, action, image = _jsx(TableNoDataImage, {}), dataTestId, }) {
    return (_jsx(TableNoDataWrapper, { className: className, "data-testid": dataTestId ?? 'there-are-no-entries', children: _jsxs(TableNoDataInnerWrapper, { children: [image, _jsx(Typography.Title, { children: message }), action || null] }) }));
});
